'use client';

import { useTransition } from 'react';

import { useParams } from 'next/navigation';

import { Locale } from '@/i18n/config';
import { usePathname, useRouter } from '@/i18n/routing';
import { cn } from '@/utils/app.utils';

import { ISelectOption } from '@/types/app.type';

import Select, { SelectProps } from '../forms/inputs/Select';

type Props = {
  defaultValue: Locale;
  options: ISelectOption<Locale>[];
  className?: string;
} & SelectProps;

const LanguageSwitcherSelect = ({
  defaultValue,
  options,
  className,
  ...props
}: Props) => {
  const router = useRouter();
  const [isPending, startTransition] = useTransition();
  const pathname = usePathname();
  const params = useParams();

  const onSelectChange = (value: Locale) => {
    startTransition(() => {
      router.replace({ pathname: pathname as string, params } as any, {
        locale: value,
      });
    });
  };

  return (
    <Select
      {...props}
      inputClassName="border-none"
      options={options}
      value={defaultValue}
      className={cn(
        {
          'transition-opacity [&:disabled]:opacity-30': isPending,
        },
        className
      )}
      onChange={onSelectChange}
    />
  );
};

export default LanguageSwitcherSelect;
